// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"22":"10f9b562","487":"29f27e0c","783":"08f5bd20"}[chunkId] + ".js";
};